import { type PrintAssetType, type PrintInitiation } from '../types/print.type';
import { usePrinterConfig } from './usePrinterConfig';

// The workstations query runs for every account, and conciliatePreferences defaults a missing
// ShippingLabel to ClickToPrint. A workstation row matched to this machine is the proof that
// preferences are real.
export const useWorkstationInitiation = (
  assetType: PrintAssetType,
): PrintInitiation | undefined => {
  const { preferences, workstation } = usePrinterConfig();

  return workstation ? preferences[assetType]?.initiation : undefined;
};
